import { Link, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { hubFor } from '@/config/roles'
import { cn } from '@/lib/cn'

/**
 * The tab bar of a hub (admin revamp, 31 Oct 2026): one menu entry over several existing screens.
 * Each tab is its own address, so every old link still opens the same page.
 */
export function HubTabs() {
  const user = useAuthStore((s) => s.user)
  const { pathname } = useLocation()
  if (!user) return null
  const hub = hubFor(pathname, { role: user.role, is_default_school: user.is_default_school })
  if (!hub) return null
  return (
    <nav aria-label="Sections of this page" data-testid="hub-tabs" className="-mx-1 mb-4 flex gap-1 overflow-x-auto border-b border-slate-200 px-1">
      {hub.tabs.map((t) => (
        <Link
          key={t.route}
          to={t.route}
          aria-current={t.route === hub.active ? 'page' : undefined}
          className={cn(
            'whitespace-nowrap border-b-2 px-3.5 py-2.5 text-title-sm font-semibold transition-colors',
            t.route === hub.active ? 'border-primary text-primary' : 'border-transparent text-slate-500 hover:text-slate-800',
          )}
        >
          {t.label}
        </Link>
      ))}
    </nav>
  )
}
